import * as en from '@kopapro-original/i18n/en.json';
import * as tw from '@kopapro-original/i18n/zh-TW.json';
import * as cn from '@kopapro-original/i18n/zh-CN.json';

import * as enExtend from '@kopapro/i18n/en.json';

export var enI18n = Object.assign({}, en, enExtend);
export var twI18n = tw;
export var cnI18n = cn;
